import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row, Spinner } from "reactstrap";
import { collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";

import DataTable from "react-data-table-component";
import AddDepartment from "./AddDepartment";
import AddRegion from "./AddRegion";
import AddDifficulty from "./AddDifficulty";
import { getDb } from "../../util/Constants";
import EditDepartment from "./EditDepartment";
import EditRegion from "./EditRegion";
import EditDifficulty from './EditDifficulty';
import EditReward from "./EditReward";
import EditMiscellaneous from './EditMiscellaneous';


function Settings(props) {
    const [departments, setDepartments] = useState([]);
    const [regions, setRegions] = useState([]);
    const [difficulties, setDifficulties] = useState([]);
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(null);
    const [departmentModal, setDepartmentModal] = useState(false);
    const [regionModal, setRegionModal] = useState(false);
    const [editDepartmentModal, setEditDepartmentModal] = useState(false);
    const [editRegionModal, setEditRegionModal] = useState(false);
    const [difficultyModal, setDifficultyModal] = useState(false);
    const [department, setDepartment] = useState({});
    const [region, setRegion] = useState({});
    const [difficultyData, setDifficultyData] = useState({});
    const [editDifficultyModal, setEditDifficultyModal] = useState(false);
    const [editRewardModal, setEditRewardModal] = useState(false);
    const [editMiscellaneousModal, setEditMiscellaneousModal] = useState(false);
    const [rewards, setRewards] = useState([]);
    const [reward, setReward] = useState({});
    const [rawObj, setRawObj] = useState({});
    const [miscellaneousData, setMiscellaneousData] = useState([]);
    const [objMiscellaneous, setObjMiscellaneous] = useState({});
    const [miscellaneous, setMiscellaneous] = useState({});
    const [projectType, setProjectType] = useState([]);
    const departmentToggle = () => {
        setDepartmentModal(!departmentModal)
    };
    const regionToggle = () => {
        setRegionModal(!regionModal)
    };
    const difficultyToggle = () => {
        setDifficultyModal(!difficultyModal);
    }


    const editDepartmentToggle = (e) => {
        setDepartment(e);
        setEditDepartmentModal(!editDepartmentModal)
    }
    const editRegionToggle = (e) => {
        setRegion(e);
        setEditRegionModal(!editRegionModal);
    }
    const editDifficultyToggle = (e) => {
        setDifficultyData(e);
        setEditDifficultyModal(!editDifficultyModal);
    }
    const editRewardToggle = (e) => {
        setReward(e)
        setEditRewardModal(!editRewardModal)
    }
    const editMiscellaneousToggle = (e) => {

        setMiscellaneous(e)
        setEditMiscellaneousModal(!editMiscellaneousModal)
    }

    useEffect(() => {
        // fetchDepartments()
        // fetchRegions()
        fetchDifficulties()
        fetchOptionsRewards()
    }, []);


    const fetchDepartments = async () => {
        setLoad(true)
        const querySnapshot = await getDocs(collection(getDb(), "departments"));
        let dataArr = []
        querySnapshot.forEach((doc) => {
            dataArr.push(
                {
                    department: doc.data().department,
                    id: doc.id,
                }
            )
        });
        setDepartments(dataArr)
        setLoad(false)
    }
    const fetchOptionsRewards = async () => {
        setLoad(true)
        let obj = {};
        let optionReward = []
        let miscellaneous = []
        let miscellaneousObj = {}
        const docRef = doc(getDb(), "util", "meta");
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {

            obj = docSnap?.data()?.optionRewards
            Object.keys(obj)?.map((key) => {
                optionReward.push({
                    rewardName: key,
                    rewardValue: obj[key]
                })
            })
            miscellaneousObj = docSnap?.data()?.miscellaneous
            Object.keys(miscellaneousObj)?.map((key) => {
                miscellaneous.push({
                    characterName: key,
                    characterValue: miscellaneousObj[key]
                })
            })

            console.log(optionReward);
            setProjectType([{ environment: docSnap?.data()?.environment }])
            setRewards(optionReward)
            setRawObj(obj)
            setMiscellaneousData(miscellaneous)
            setObjMiscellaneous(miscellaneousObj)

        } else {
            // docSnap.data() will be undefined in this case

        }
        setLoad(false)

    }
    const fetchRegions = async () => {
        setLoad(true)
        const querySnapshot = await getDocs(collection(getDb(), "regions"));
        let dataArr = []
        querySnapshot.forEach((doc) => {
            dataArr.push(
                {
                    region: doc.data().region,
                    id: doc.id

                }
            )
        })
        setRegions(dataArr)
        setLoad(false)
    }
    const fetchDifficulties = async () => {
        setLoad(true)
        const querySnapshot = await getDocs(collection(getDb(), "levelDifficultyScores"));
        let dataArr = []
        querySnapshot.forEach((doc) => {
            dataArr.push(
                {
                    difficulty: doc.data().difficulty,
                    passingScore: doc.data().passingScore,
                    id: doc.id

                }
            )
        })
        setDifficulties(dataArr)
        // setLoad(false)
    }


    const column1 = [
        {
            name: 'Department',
            selector: row => row.department,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>

                    <Button onClick={() => editDepartmentToggle(row)} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button>
                    <Button
                        color="white"
                        size="sm"
                        onClick={async () => {
                            setLoading(`deleting_${row.id}`);
                            await deleteDoc(doc(getDb(), "departments", row.id));
                            setDepartments(departments.filter((e) => e.id !== row.id))
                            setLoading(null);
                        }}
                    >
                        {
                            loading === `deleting_${row.id}` ?
                                <Spinner
                                    className="mx-2"
                                    color="dark"
                                    size={'sm'}
                                >
                                    Loading...
                                </Spinner> : <i className="text-danger far fa-trash-alt" />
                        }
                    </Button>
                </>)
        }
    ];
    const column2 = [
        {
            name: 'Region',
            selector: row => row.region,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>
                    <Button onClick={() => editRegionToggle(row)} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button>
                    <Button
                        color="white"
                        size="sm"
                        onClick={async () => {
                            setLoading(`deleting_${row.id}`);
                            await deleteDoc(doc(getDb(), "regions", row.id));
                            setRegions(regions.filter((e) => e.id !== row.id))
                            setLoading(null);
                        }}
                    >
                        {
                            loading === `deleting_${row.id}` ?
                                <Spinner
                                    className="mx-2"
                                    color="dark"
                                    size={'sm'}
                                >
                                    Loading...
                                </Spinner> : <i className="text-danger far fa-trash-alt" />
                        }
                    </Button>

                </>)
        }

    ];
    const column3 = [
        {
            name: 'Difficulty',
            selector: row => row.difficulty,
        },
        {
            name: 'Passing Score',
            selector: row => row.passingScore,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>

                    <Button onClick={() => editDifficultyToggle(row)} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button>
                    {/*<Button*/}
                    {/*    color="white"*/}
                    {/*    size="sm"*/}
                    {/*    onClick={async () => {*/}
                    {/*        setLoading(`deleting_${row.id}`);*/}
                    {/*        await deleteDoc(doc(getDb(), "levelDifficultyScores", row.id));*/}
                    {/*        setDifficulties(difficulties.filter((e) => e.id !== row.id))*/}
                    {/*        setLoading(null);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {*/}
                    {/*        loading === `deleting_${row.id}` ?*/}
                    {/*            <Spinner*/}
                    {/*                className="mx-2"*/}
                    {/*                color="dark"*/}
                    {/*                size={'sm'}*/}
                    {/*            >*/}
                    {/*                Loading...*/}
                    {/*            </Spinner> : <i className="text-danger far fa-trash-alt" />*/}
                    {/*    }*/}
                    {/*</Button>*/}


                </>)
        }
    ];
    const column4 = [
        {
            name: 'Reward',
            selector: row => row?.rewardName?.charAt(0)?.toUpperCase() + row?.rewardName.slice(1),
        },
        {
            name: 'Value',
            selector: row => row.rewardValue,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>

                    <Button onClick={() => editRewardToggle(row)} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button>
                    {/*<Button*/}
                    {/*    color="white"*/}
                    {/*    size="sm"*/}
                    {/*    onClick={async () => {*/}
                    {/*        setLoading(`deleting_${row.id}`);*/}
                    {/*        await deleteDoc(doc(getDb(), "levelDifficultyScores", row.id));*/}
                    {/*        setDifficulties(difficulties.filter((e) => e.id !== row.id))*/}
                    {/*        setLoading(null);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {*/}
                    {/*        loading === `deleting_${row.id}` ?*/}
                    {/*            <Spinner*/}
                    {/*                className="mx-2"*/}
                    {/*                color="dark"*/}
                    {/*                size={'sm'}*/}
                    {/*            >*/}
                    {/*                Loading...*/}
                    {/*            </Spinner> : <i className="text-danger far fa-trash-alt" />*/}
                    {/*    }*/}
                    {/*</Button>*/}


                </>)
        }
    ];
    const column5 = [
        {
            name: 'Characters',
            selector: row => row?.characterName,
        },
        {
            name: 'Name',
            selector: row => row?.characterValue,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>

                    <Button onClick={() => editMiscellaneousToggle(row)} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button>
                    {/*<Button*/}
                    {/*    color="white"*/}
                    {/*    size="sm"*/}
                    {/*    onClick={async () => {*/}
                    {/*        setLoading(`deleting_${row.id}`);*/}
                    {/*        await deleteDoc(doc(getDb(), "levelDifficultyScores", row.id));*/}
                    {/*        setDifficulties(difficulties.filter((e) => e.id !== row.id))*/}
                    {/*        setLoading(null);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {*/}
                    {/*        loading === `deleting_${row.id}` ?*/}
                    {/*            <Spinner*/}
                    {/*                className="mx-2"*/}
                    {/*                color="dark"*/}
                    {/*                size={'sm'}*/}
                    {/*            >*/}
                    {/*                Loading...*/}
                    {/*            </Spinner> : <i className="text-danger far fa-trash-alt" />*/}
                    {/*    }*/}
                    {/*</Button>*/}


                </>)
        }
    ];
    const column6 = [
        {
            name: 'Project Type',
            selector: row => row?.environment,
        },
        {
            name: '',
            center: true,
            width: '150px',
            selector: row => null,
            cell: row => (
                <>

                    {/* <Button  onClick={()=>{
                        updateDoc()
                    }} color="primary" size="sm">
                        <i className="fas fa-pen" />
                    </Button> */}
                    {/*<Button*/}
                    {/*    color="white"*/}
                    {/*    size="sm"*/}
                    {/*    onClick={async () => {*/}
                    {/*        setLoading(`deleting_${row.id}`);*/}
                    {/*        await deleteDoc(doc(getDb(), "levelDifficultyScores", row.id));*/}
                    {/*        setDifficulties(difficulties.filter((e) => e.id !== row.id))*/}
                    {/*        setLoading(null);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {*/}
                    {/*        loading === `deleting_${row.id}` ?*/}
                    {/*            <Spinner*/}
                    {/*                className="mx-2"*/}
                    {/*                color="dark"*/}
                    {/*                size={'sm'}*/}
                    {/*            >*/}
                    {/*                Loading...*/}
                    {/*            </Spinner> : <i className="text-danger far fa-trash-alt" />*/}
                    {/*    }*/}
                    {/*</Button>*/}


                </>)
        }

    ]


    return (
        <>


            <Container fluid>
                <Row>
                    {/* <Col md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Departments</h1>
                            <Button className='btn btnColor border-0 mb-1' onClick={departmentToggle}>Add Department</Button>
                        </div>
                        <Card>

                            <DataTable
                                columns={column1}
                                data={departments}
                                progressPending={load}
                                pagination={true}

                            />
                        </Card>
                    </Col>

                    <Col md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Regions</h1>
                            <Button className='btn btnColor border-0 mb-1' onClick={regionToggle}>Add Region</Button>
                        </div>
                        <Card>



                            <DataTable
                                columns={column2}
                                data={regions}
                                progressPending={load}
                                pagination={true}
                            />
                        </Card>
                    </Col> */}
                    <Col className=' mb-3' md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Question Reward</h1>
                            {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                        </div>
                        <Card>

                            <DataTable
                                columns={column4}
                                data={rewards}
                                progressPending={load}

                            />
                        </Card>
                    </Col>

                    <Col className=' mb-3' md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Level Difficulty</h1>
                            {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                        </div>
                        <Card>
                            <DataTable
                                columns={column3}
                                data={difficulties}
                                progressPending={load}

                            />
                        </Card>
                    </Col>
                    <Col className=' mb-3' md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Characters</h1>
                            {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                        </div>
                        <Card>
                            <DataTable
                                columns={column5}
                                data={miscellaneousData}
                                progressPending={load}

                            />
                        </Card>
                    </Col>
                    <Col className=' mb-3' md={"6"}>
                        <div className="d-flex justify-content-between">
                            <h1 className="mb-0 custom-font letterSpacing">Project Type</h1>
                            {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                        </div>
                        <Card>
                            <DataTable
                                columns={column6}
                                data={projectType}
                                progressPending={load}

                            />
                        </Card>
                    </Col>
                </Row>
            </Container>

            <AddDepartment modal={departmentModal} toggle={departmentToggle} departments={departments}
                getDepartments={fetchDepartments}
                setDepartments={setDepartments} />
            <AddRegion modal={regionModal} toggle={regionToggle} regions={regions} setRegions={setRegions}
                getRegions={fetchRegions} />
            <AddDifficulty modal={difficultyModal} toggle={difficultyToggle} getDifficulties={fetchDifficulties} />


            {editDepartmentModal &&
                <EditDepartment modal={editDepartmentModal} toggle={editDepartmentToggle} item={department}
                    getDepartments={fetchDepartments} />}
            {editRegionModal &&
                <EditRegion modal={editRegionModal} toggle={editRegionToggle} item={region}
                    getRegions={fetchRegions} />
            }

            {editDifficultyModal &&
                <EditDifficulty modal={editDifficultyModal} toggle={editDifficultyToggle} item={difficultyData}
                    getDifficulties={fetchDifficulties} />}


            <EditReward modal={editRewardModal} toggle={editRewardToggle} item={reward} Obj={rawObj}
                getOptions={fetchOptionsRewards} />

            <EditMiscellaneous modal={editMiscellaneousModal} toggle={editMiscellaneousToggle} item={miscellaneous} Obj={objMiscellaneous}
                getOptions={fetchOptionsRewards} />
        </>


    );
}

export default Settings;